import type { AllRouteEndpoints } from "../routeTypes";
export const alloysPartnerAttributionAppGroupId = "/alloys/:partner/attribution/:app_group_id";

export const postAlloysPartnerAttributionAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  alloysPartnerAttributionAppGroupId,
];

export const deleteAlloysPartnerAttributionAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  alloysPartnerAttributionAppGroupId,
];
